import api from '@/api/comment'
import { getContextPath, isDef, isPlainObject, toString,isMobile } from 'utils'
import KingGridElecseal from 'utils/KingGridElecseal'
import { loadKingGridRes, loadEseal } from 'utils/loadResources'
import showFileSign from 'utils/FileSign'
import getUserInfo from 'utils/ESeal'
import { initHandler } from 'utils/ESeal'
const ContextPath = getContextPath()
const newEsealTypes = ['2', '3']
import NuoSeal from '../components/nuo-seal/utils/seal'
const EmapflowComment = {
  data() {
    return {
      loadSeal: ContextPath + "/sys/emapflow/elecseal/loadSeal.do",
      asyncOptions: [],
      isFinishedTask: false, // 标识流程业务是否为已办结
      flowComments: [],
      seals: [],
      approval: this.value?.approval,
      approval_display: this.value?.approval_display,
      comment: this.value?.comment,
      chapterWID: this.value?.elecseal || '',
      chapterUrl: [],
      errorMsg: {
        optsRequired: this.$LocalH5('validCommentRequired'),
        commentRequired:this.$LocalH5('vaildComment'),
        sealRequired: this.$LocalH5('sealOrSign.validSeal'),
        signatureRequired: this.$LocalH5('sealOrSign.validSign'),
        multipleRequired: this.$LocalH5('sealOrSign.validSealAndSign')
      },
      defaultComments: [],
      signatureType: '1', // '1'--原始签章，'2'--金格签章，'3'--E签宝
      signatureUser: '',
      signatureJGUrl: '',
      getSealLoading: false,
      sealObj: {
        name: '',
        mimetype: '',
        sid: '',
        sealFile: ''
      },
      elecsealLoading: false,
      newProtectedItems: null,
      newVerifyData: null,
      kinggridGai: false,
      sealMap: {},
      hasLoaded: false,
      getUserInfoLoaded: false,
      sealConfigData: null,
      flowParamsData: null,
      nuoSeal: null
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },      
    processInstanceId: String,
    taskId: String ,
    approvalUrl: String,
    options: Array,  // 数据格式[{id:"true",name:"同意"},{id:"false",name:"不同意"}]
    showOldComment: {
      type: Boolean,
      default: true
    },
    showCurComment: {
      type: Boolean,
      default: true
    },
    required: Boolean,          // 审批意见文本是否必填
    opprovalRequired: Boolean,  // 审批意见选项是否必选
    needElecseal: Boolean,      // 审批意见电子印章是否必选
    needEsignature: Boolean,    // 审批意见电子签名是否必选
    elecseal: Boolean,          // 开启电子印章
    esignature:Boolean,         // 开启电子签名
    esignAutoSel: Boolean,      // 电子签名自动选中
    schema: {
      type: String,
      default: 'default'        // 三种模式：默认模式('default')、简易模式('simple')、签章模式('signing')
    },
    label: String,
    hidden: Boolean,
    readonly: Boolean,
    sealMode: {
      type: String,
      default: 'default'// 'default'/'kinggrid'
    },
    kinggrid: {
      type: Object,
      default: () => null
    },
    eseal: {
      type: Object,
      default: () => null
    },
    defKey: String,
    bizKey: String,
    sample: Boolean,
    getVerifyData: Function,
    sealverify: Boolean,       // 签章是否需要二次验证
    clip: Boolean,             // 电子签名空白边框裁剪
    multiple: Boolean,         // 电子印章支持双选，默认单选
    checkboxOnly: Boolean,
    spread: Boolean,           // 历史意见默认展开
  },
  watch: {
    "value.comment": {
      handler: function(newVal, oldVal) {
        if(newVal !== oldVal) {
          this.comment = newVal;
        }
      },
      deep: true
    },
    "value.elecseal": {
      handler: function(newVal, oldVal) {
        if(newVal != oldVal && !newEsealTypes.indexOf(this.signatureType)>-1) {
          this.chapterWID = newVal || '';
          this.chapterUrl = this.transferChanpterUrl(newVal);
        }
      },
      deep: true
    },
    'value.approval': {
      handler(val) {
        this.approval = val;
        if(this.checkboxOnly && this.approval_checkbox !== undefined) this.approval_checkbox = val === '' ? false : true;
      }
    },
    'value.approval_display': {
      handler(val) {
        this.approval_display = val
      }
    },
    'value.options':{
      handler(val){
        console.log(val,'---value.options---');
      }
    }
  },
  computed: {
    mergeOptions() {
      let arr =this.options || this.asyncOptions || []
      if(this.readonly) {
        return arr.map(option => {
          option.disabled = true;
          return option
        })
      } else {
        return arr
      }
    },
    showInput() {
      return ['default','simple'].indexOf(this.schema) > -1
    },
    commentObj() {
      return {
        approval: this.approval,
        approval_display: this.approval_display,
        comment: this.comment,
        elecseal: this.chapterWID
      }
    },
    iskinggrid() {
      return !!(this.kinggrid && this.kinggrid.documentid)
    }
  },
  methods: {
    emitInput() {
      let inputValues = Object.assign({}, this.commentObj);
      if(this.commentObj.approval == null) {
        delete inputValues.approval;
        delete inputValues.approval_display;
      }
      if(this.commentObj.elecseal == null) delete inputValues.elecseal;
      this.$emit('input', inputValues)
    },
    transferChanpterUrl(values) {
      if(!values) {
        return [];
      }
      let urls =[];
      if(values.indexOf(',') > -1) {
        values.split(',').forEach(value => {
          urls.push(this.loadSeal + '?wid=' + value + "&_=" + new Date().getTime());
        })
      } else {
        urls = [this.loadSeal + '?wid=' + values + "&_=" + new Date().getTime()];
      }
      return urls;
    },
    /**
     * 校验
     */
    validateDefault() {
      let result = {
        valid: true
      }
      // taskId不存在，即表示为启动，跳过校验
      if(this.schema === 'default') {
        if(!this.taskId || this.isFinishedTask || this.readonly || this.hidden || !this.showCurComment) return result
      }
      
      if(this.schema !== 'signing') {
        if(this.opprovalRequired && !this.approval) {
          result = {
            key: 'approval',
            msg: this.errorMsg.optsRequired,
            valid: false
          }; 
          return result
        }
        if(this.required) {
          if(this.mergeOptions && this.mergeOptions.length && this.approval) {
            let option = this.mergeOptions.filter((opt)=>{ return opt.id === this.approval})[0];
            if(option && option.needComment != undefined) {
              if(!this.comment && option.needComment) {
                result = {
                  key: 'comment',
                  msg: this.errorMsg.commentRequired,
                  valid: false
                }; 
                return result
              }
            } else {
              if(!this.comment) {
                result = {
                  key: 'comment',
                  msg: this.errorMsg.commentRequired,
                  valid: false
                }; 
                return result
              }
            }
          } else {
            if(!this.comment) {
              result = {
                key: 'comment',
                msg: this.errorMsg.commentRequired,
                valid: false
              }; 
              return result
            }
          }
        }
      }
      if(this.multiple && this.needElecseal && this.needEsignature) {
        if(this.chapterWID.indexOf(",") === -1) {
          return {
            key: 'multiple',
            msg: this.errorMsg.multipleRequired,
            valid: false
          }
        }
      } else {
        if(this.needElecseal && !this.chapterWID) {
          result = {
            key: 'elecseal',
            msg: this.errorMsg.sealRequired,
            valid: false
          }; 
          return result
        }
        if(this.needEsignature && !this.chapterWID) {
          result = {
            key: 'esignature',
            msg: this.errorMsg.signatureRequired,
            valid: false
          }; 
          return result
        }
      }
      return result
    },
    normalizeProtectedItems(protectedItems) {
      if (protectedItems && isPlainObject(protectedItems)) {
        const newProtectedItems =  JSON.parse(JSON.stringify(protectedItems))
        const obj = {}
        if (this.kinggrid.protectedItems) {
          Object.keys(this.kinggrid.protectedItems).forEach(key => {
            let val = newProtectedItems[key]
            if (!isDef(val)) {
              val = ''
            }
            obj[key] = toString(val)
          })
        } else {
          Object.keys(newProtectedItems).forEach(key => {
            let val = newProtectedItems[key]
            if (!isDef(val)) {
              val = ''
            }
            obj[key] = toString(val)
          })
        }
        return obj
      } else {
        return {}
      }
    },
    initKingGrid() {
      const that = this
      if (!this.kinggrid) return 
      const { documentid, handleVerify } = this.kinggrid
      this.KingGridElecsealIns = new KingGridElecseal({
        keysn: this.signatureUser,
        documentid,
        handleVerify,
        serverUrl: this.signatureJGUrl,
        protectedItems: this.kinggrid.protectedItems,
        getVerifyData: this.getVerifyData,
        //执行盖章动作的回调
        okCallHook(fn, image, pos) {
          that.elecsealLoading = true
          const sid = this.getSignatureid()
          const sdata = this.getSignatureData()
          const seal = this.signatureData && this.signatureData.seal
          that.sealObj.mimetype = seal.imgext
          that.sealObj.name =  image.name
          that.sealObj.sid = sid
          const base64pre = 'data:image/png;base64'
          const imagedata = base64pre.replace('png',seal.imgext.slice(1)) + ',' + seal.imgdata
          that.sealObj.sealFile = imagedata
          that.addJGSeal((wid) => {
            that.setPosChapsterState(pos, true, { sid, sdata })
            if (that.signatureType == '2') {
              that.kingGridPushWid(wid)
            }
            that.setKingGridMap(sid, wid)
            fn(true)
            //保存签章
            that.KingGridElecsealIns.saveKingGridSignnature(sid, sdata)
            that.kinggridGai = true
            if (that.chapterUrl.length) that.chapterUrl = []
            that.hideSealSelectModal()
            if (that.dialog && that.dialog.remove) {
              that.dialog.remove()
            }
          })
        },
        showCallHook(content, dialog, onOk, u) {
          that.u = u
          that.showSealSelectModal()
          that.$nextTick(() => {
            const elecsealWrapper = that.getKingGridContentWrap(that.$refs['sealModal'])
            if (elecsealWrapper.childNodes.length) {
              elecsealWrapper.removeChild(elecsealWrapper.childNodes[0])
            }
            elecsealWrapper.appendChild(content[0])
            that.kingGridCon = content
            that.dialogObj = dialog
            that.dialog = dialog['0']
            that.onOk = onOk
          })
        }
      })
    },
    deleteAsyncOpt(signatureid) {
      const wid = this.getKingGridMapVal(signatureid)
      this.deleteJGseal(wid)
    },
    deleteHook(signatureid, pos) {
      this.setPosChapsterState(pos, false, { sid: '', sdata: null })
      if (this.dialog && this.dialog.remove) {
        this.dialog.remove()
      }
      const wid = this.getKingGridMapVal(signatureid)
      this.delKingGridMap(wid)
      this.removeKingGridWid(wid)
      this.curOptPos = pos
    },
    createKingGridSeal(posId) {
      this.KingGridElecsealIns && this.KingGridElecsealIns.runSignatureCreator(posId)
    },
    customProtectedItems(protectedItems) {
      const result = []
      if (!protectedItems) return result
      const keys = Object.keys(protectedItems)
      if (!keys.length) return result
      keys.map(key => {
        if (!/^___/.test(key) && !/_DISPLAY$/.test(key)) {
          const obj = {}
          obj['field'] = key
          if (isDef(protectedItems[key]) && typeof(protectedItems[key]) !== 'string') {
            protectedItems[key] = String(protectedItems[key])
          }
          obj['value'] = protectedItems[key]
          obj['desc'] = `保护项--${key}`
          result.push(obj)
        }
      })
      return result
    },
    getSaveSignatures(commentList) {
      const _this = this
      return new Promise((resolve) => {
        if (this.KingGridElecsealIns) {
          //获得对应文档下的签章
          this.KingGridElecsealIns.getSaveSignatures().then(signs => {
            const signdata = new Array()
            const posArray = new Array()
            const jsonList = eval("("+signs+")")
            let index = 0
            commentList = commentList.map((item) => {
              if (item.sealSid) {
                const sealIdArrs = item.sealSid.split(',')
                item['pos'] = []
                for (let [sealIndex, sealId] of sealIdArrs.entries()) {
                  const listItem = jsonList.find(childItem => childItem['signatureId'] === sealId)
                  if (listItem) {
                    const map = {}
                    const mapPos = {}
                    mapPos.signatureid = map.signatureid = listItem["signatureId"]
                    _this.sealMap[map.signatureid] = {
                      wid: item['elecseal'].split(',')[sealIndex],
                      sealVaild: item['sealValid'].split(',')[sealIndex]
                    }
                    map.signatureData = listItem["signature"]
                    signdata.push(map)
                    const pos = 'pos--' + index
                    mapPos.extra = {
                      position: pos
                    }
                    item['pos'].push(pos)
                    index++
                    posArray.push(mapPos)
                  }
                }
              }
              return item
            })
            resolve({signdata, posArray, commentList})
          })
        }
      })
    },
    addJGSeal(callback) {
      api.addJGSeal(this.sealObj).then((res) => {
          if(res && res.code === "0" && res.datas && res.datas.addJGSeal) {
            const chapterWID = res.datas.addJGSeal
            callback(chapterWID)
          } else {
            this.$Message.error(res.msg)
          }
          this.elecsealLoading = false
        }).catch(err => {
          console.error(err)
          this.elecsealLoading = false
          this.$Message.error('盖章失败!')
        })
    },
    deleteJGseal(WID, callback) {
      api.deleteJGSeal({ WID }).then((res) => {
          if(res && res.code === "0") {
            callback && callback()
            if (this.kinggridGai) this.kinggridGai = false
          } else {
            this.$Message.error(res.msg)
          }
        }).catch(err => {
          console.log(err)
        })
    },
    
    /**
     * 
     * @returns 获取历史审批意见接口  
     */
    getFlowComments() {
      this.historyLoading = false;
      return new Promise((resolve, reject) => {
        api.getCommentRecords({
         "processInstanceId": this.processInstanceId,
         "taskId": this.taskId
        }).then(data => {
          if(data.flowComments && Object.prototype.toString.call(data.flowComments) === '[object Array]'){
            const flowComments = data.flowComments.map(obj => {
              obj.elecsealurl = this.transferChanpterUrl(obj.elecseal);
              return obj
            });
            if(!flowComments.length) this.historyEmpty = true;
            resolve(flowComments)
          } else {
            reject(data)
          }
          this.historyLoading = false;
        })
      })
    },
    /**
     * 
     * @returns 获取签章模式接口（signatureType为'1'默认原始模式,signatureType为'2'金格印章）
     */
    getSealConfig() {
      return new Promise((resolve, reject) => {
        this.getSealLoading = true
        api.getSealConfig({}).then((data) => {
          this.getSealLoading =  false
          this.sealConfigData = data
          if (data.code === '0' && data.datas && data.datas.getSealConfig) {
            const { signatureType, signatureUrl, signatureUser } = data.datas.getSealConfig
            //方便测试
            this.signatureType = signatureType || '1'
            this.signatureUser = signatureUser
            this.$emit('signature-type-change', this.signatureType)
            this.signatureJGUrl = signatureUrl
            if (this.signatureType == '2') {
              // this.signatureUser = 'T001'
              // this.signatureJGUrl = 'http://171.34.78.70:8899/iSignatureHTML5/html5'
              if (this.signatureJGUrl && this.signatureUser) {
                !this.hasLoaded && loadKingGridRes().then(() => {
                  if (typeof(Signature.initCount) === 'undefined') {
                    Signature.initCount = 0
                  }
                  if (typeof(Signature.kingGridVmMap) === 'undefined') {
                    Signature.kingGridVmMap = {}
                  }
                  this.hasLoaded = true
                  this.initKingGrid()
                  if ((this.elecseal || this.esignature) && this.schema === 'signing') {
                    this.KingGridElecsealIns && this.chapterWID && this.signingInit(this.KingGridElecsealIns, this.chapterWID)
                  }
                  resolve(data)
                })
              } else {
                resolve(data)
                console.error('初始化金格失败')
              }
            } else {
              resolve(data)
            }
          } else {
            reject(data)
          }
        }).catch(err => {
          this.getSealLoading =  false
          reject(err)
        })
      })
    },
    
    //表单值变化实时验证印章
    linkFormChange() {
      if (this.signatureType == '2') {
        Promise.resolve().then(() => {
          this.KingGridElecsealIns && this.KingGridElecsealIns.verify()
        })
      }
    },
    getSealPos(signatureData) {
      if (signatureData.position && isPlainObject(signatureData.position)) {
        const pos = signatureData.position
        const keys = Object.keys(pos)
        if (keys.length) {
          return keys[0]
        } else {
          console.error('无法获取对应签章位置')
        }
      } else {
        console.error('无法获取对应签章位置')
      }
    },
    updateJGSeal(data, callback) {
      api.updateJGSeal(data).then((res) => {
        if(res && res.code === "0") {
          callback()
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    showSealSelectModal() {
      this.elecsealSelectModel = true
      this.chapterPopup = true
    },
    hideSealSelectModal() {
      this.elecsealSelectModel = false
      this.chapterPopup = false
    }
  },
  async created() {
    if (this.schema === 'simple') return 
    // taskId为 空字符串，标识当前为启动状态，根据这一特点，可以确定不是最后一个节点；如果[isFinishedTask = true],隐藏下一步组件
    if(this.schema === 'default' && this.taskId ) {
      await api.getFlowParams({ 
        "taskId": this.taskId 
      }).then(data => {
        this.flowParamsData = data
        if(data &&data.items) {
          this.isFinishedTask = data.items.isFinishedTask;
          // 兼容易表通1.0版本
          if(this.isFinishedTask && this.$el.parentElement && this.$el.parentElement.nodeName === 'TD') {
            this.$el.parentElement.parentElement.style.display = 'none';
          }
        }
      })
    }
    // 只读模式，默认根据WID显示图片，无需根据signatureType判断是否引入第三方插件 2021/1/14 wyj
    if (!this.showOldComment || !this.taskId) {
      // 流程处于启动环节，且不显示历史记录 -- getSealConfig这部分业务逻辑应独立于组件外，置于组件内太重了（待完成）
      this.getSealConfig().then(() => {
        this.nuoSeal = new NuoSeal({
          sealConfig: this.sealConfigData,
          flowParams: this.flowParamsData,
          emapFlowCommentCpmponentVm: this,
          mode: 'readonly'
        })
        if (this.signatureType == '3' && (this.elecseal || this.esignature) && this.schema === 'default') {
          if (!(this.eseal && this.eseal.documentid)) {
            throw new Error('bizkey必传')
          }
          //加载E签宝所需基础资源
          !this.hasLoaded && loadEseal().then(() => {
            // eslint-disable-next-line
            initHandler()
            getUserInfo(this.signatureJGUrl, this.signatureUser).then((userInfo) => {
              window.showFileSign = showFileSign(userInfo, this.signatureJGUrl)
              window.handler.init(userInfo, this.signatureJGUrl)
              this.hasLoaded = true
              this.$nextTick(() => {
                const comp = this.$refs.eSeal && this.$refs.eSeal.$children && this.$refs.eSeal.$children[0]
                window.handler && window.handler.bindSubmit && window.handler.bindSubmit(this, comp)
              })
            })
          })
        }
      }).catch(err => {
        console.log(err)
      })
    } else {
      /* eslint-disable */
      Promise.all([this.getSealConfig(), this.getFlowComments()]).then(([configdata, flowComments]) => {
        this.nuoSeal = new NuoSeal({
          sealConfig: this.sealConfigData,
          flowParams: this.flowParamsData,
          emapFlowCommentCpmponentVm: this
        })
        if (this.signatureType == '2') {
           this.getSaveSignatures(flowComments).then(({signdata, posArray, commentList}) => {
             //提供绘制容器
             this.flowComments = commentList
             this.$nextTick(() => {
               //初始化验签并渲染然后更新对应章的图片
               this.kingGridInitLoadAndVerify(this.KingGridElecsealIns, { sealMap: this.sealMap, signdata, posArray })
             })
           })
        } else if (this.signatureType == '3') {
          if (!(this.eseal && this.eseal.documentid)) {
            console.error('bizkey必传')
            return
          }
          const _this = this;
           //加载E签宝所需基础资源
          !this.hasLoaded && loadEseal().then(() => {
            // eslint-disable-next-line
            initHandler()
            getUserInfo(this.signatureJGUrl, this.signatureUser).then((userInfo) => {
              window.showFileSign = showFileSign(userInfo, this.signatureJGUrl)
              window.handler.init(userInfo, this.signatureJGUrl)
              localStorage.setItem('__handler-server-url__', this.signatureJGUrl)
              localStorage.setItem('__handler-userinfo__', JSON.stringify(userInfo))
              this.hasLoaded = true
              this.$nextTick(() => { 
                const comp = this.$refs.eSeal && this.$refs.eSeal.$children && this.$refs.eSeal.$children[0]
                window.handler && window.handler.bindSubmit && window.handler.bindSubmit(this, comp)
                if (window.handler) {
                  //初始加载绘制对应签章
                  window.handler.loadingSignatures && window.handler.loadingSignatures()
                  this.esealMap = {}
                  //根据流程意见列表筛选出需要渲染和数据保护的列表
                  window.handler.setPos = function(arrs) {
                    const map = _this.esealMap
                    const newArr = []
                    const newFlowComments = JSON.parse(JSON.stringify(flowComments))
                    newFlowComments.forEach(sign => {
                      map[sign['sealSid']] = sign
                    })
                    for (let i = 0; i < arrs.length; i++) {
                      const sign = arrs[i]
                      const comment = map[sign['signlogId']]
                      if (comment) {
                        let pos = comment.pos || (comment.pos = [])
                        sign.domId = `pos${i}`
                        pos.push(sign.domId)
                        newArr.push(sign)
                      }
                    }
                    //设置绘制容器
                    _this.flowComments = newFlowComments
                    return newArr
                  }
                  _this.flowComments = flowComments
                }
              })
            }).catch(err => {
              console.log(err)
            })
          })
        } else {
          // 只有pc端需要进行自动验签功能
          if(!isMobile()){
            this.flowComments = flowComments
            this.autoCheckAllSign && this.autoCheckAllSign(flowComments) // 新增自动验签功能
          }
        }
      }).catch(err => {
        console.log(err)
      })
      /* eslint-enable */
    }
  },
  mounted () {
    // chapterUrl获取\
    if(this.value && this.value.elecseal) {
      this.chapterUrl = this.transferChanpterUrl(this.value.elecseal);
    }

    // 获取意见审批字典绑定的数据options
    if(!this.options && this.approvalUrl) {
      api.getCustomUrl(this.approvalUrl).then(data => {
        if(data && data.code === '0') {
          let result = data.datas;
          if(result.code && result.code.rows) {
            this.asyncOptions = result.code.rows;
          }
        }
      })
    }

    // 判断是否默认显示签名
    if(this.schema === 'default' && this.esignature && this.esignAutoSel) {
      api.getSeals().then(data => {
        if(data.code == '0'){
          let rows = data.datas.queryMySeals.rows;
          let esign = rows.filter(row => row.STYPE === '1');
          if(esign.length) {
            this.chapterWID = esign[0].WID;
            this.chapterUrl = this.transferChanpterUrl(esign[0].WID);
            this.emitInput();
          }
        } else {
          throw new Error(data.msg);
        }
      });
    }
  },
  beforeDestroy() {
    this.KingGridElecsealIns = null
  }
}

export default EmapflowComment